import React, { useContext } from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import noop from '../../utils/noop';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import StageBackground from '../../DeviationBackground/StageBackground';
import Full from '../../DeviationViews/Full';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { useMobileStage } from '../hooks/useMobileStage';
import Duperswiper from '../_partials/Duperswiper';
import ZoomModalFromImageSource from '../_partials/ZoomModalFromImageSource';
import { DefaultArtStageProps as Props } from '../types';

import styles from './MobileArtStage.scss';

// meant to match MobileMultiArtCarouselStage's CURRENT_IMAGE_MAX_HEIGHT
const MOBILE_STAGE_MAX_HEIGHT = 411;

// precondition: the following Desktop DeviationTypes don't end up here:
//   POLL, STATUS, COMMISSION, TIER, JOURNAL, LITERATURE (they have their own ArtStages)
// that currently leaves:
//   UNKNOWN, IMAGE, FILM, PDF

const MobileSingleArtStage: React.FC<Props> = ({
  deviation,
  className,
  zoomedImageSource,
  isZoomed,
  onEnterZoomMode = noop,
  onExitZoomMode = noop,
}) => {
  const { contentSize, containerSize } = useMobileStage(deviation, MOBILE_STAGE_MAX_HEIGHT);

  // polls and statuses put all their content into the art stage and thus need to be unlimited in height
  const noStageHeight = [DeviationTypes.POLL, DeviationTypes.STATUS].includes(
    getDeviationType(deviation)
  );

  const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);

  return (
    <div className={cn(className, styles['root'])}>
      <Duperswiper
        key={deviation.deviationId}
        deviation={deviation}
        height={noStageHeight ? 'auto' : containerSize?.height}
        width={'auto'}
        isInZoomModal={isZoomed}
      >
        {dev => (
          <>
            <StageBackground
              deviation={dev}
              height={containerSize?.height}
              width={containerSize?.width}
            />

            <Full
              deviation={dev}
              width={contentSize?.width}
              height={noStageHeight ? undefined : contentSize?.height}
              withoutZoomModal
              isZoomed={isZoomed}
              onEnterZoomMode={onEnterZoomMode}
              onExitZoomMode={onExitZoomMode}
            />

            {zoomedImageSource && (
              <ZoomModalFromImageSource
                source={zoomedImageSource}
                allowFullviewSrcsetForPngs={
                  (zoomedImageSource as PapiDeviation)?.isPublished ?? false
                }
                {...contentSize}
                isZoomed={isZoomed}
                onExitZoomMode={onExitZoomMode}
              />
            )}

            {isSubscriptionPurchaseFTUEBeingShown && <SubscriptionPurchaseFTUE />}
          </>
        )}
      </Duperswiper>
    </div>
  );
};
MobileSingleArtStage.displayName = 'MobileSingleArtStage';
export default MobileSingleArtStage;
